// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","llc":"Footer_llc__nyVCM","logo":"Footer_logo__+SElo"};